import {extend} from 'lodash'
import Storage from './storage'

const prefix = `${process.env.VUE_APP_NAME}_${process.env.VUE_APP_NODE_ENV}_v1_`
const isEncrypt = process.env.VUE_APP_NODE_ENV === 'production'
const local = new Storage({prefix, isEncrypt})
const session = new Storage({prefix, isEncrypt, driver: sessionStorage})

export default extend(local, {local, session})
